// TODO: REFACTORING
import React, { useState } from 'react';
import Style from './style.module.css';
import Chip from '../Chip';
import { translate as t } from '../../utils/translate';

const AircraftAbout = ({ title, chips, imgSrc, note, flightPage }) => {
  const [showAllChips, setShowAllChips] = useState(true);

  const TEXTS = {
    DETAILS: t('details'),
    SEE_MORE: t('seeMore'),
  };

  return (
    <section
      className={[
        Style.aircraftAbout,
        flightPage ? Style.flightPage : 'container',
      ].join(' ')}
    >
      <h2 className={Style.header}>{TEXTS.DETAILS}</h2>
      <div className={Style.content}>
        <div className={Style.imageContainer}>
          <img className={Style.image} src={imgSrc} />
        </div>
        <div
          className={[
            Style.itemContainer,
            flightPage && !showAllChips && chips.length > 3
              ? Style.hideSomeChips
              : '',
          ].join(' ')}
        >
          {chips.map((chip, idx) => (
            <Chip key={idx} {...chip} />
          ))}
          {flightPage && !showAllChips && chips.length > 3 && (
            <span
              onClick={() => setShowAllChips(true)}
              className={Style.seeMore}
            >
              {TEXTS.SEE_MORE}
            </span>
          )}
        </div>
      </div>
      <p className={Style.bottomText}>{note}</p>
    </section>
  );
};

export default AircraftAbout;
